export default __webpack_public_path__ + "static/Graphik-Light-Cy-Web-bfbf8fcd6425ae6bcad2c76008df495c.woff2";